import { ReactNode } from "react";
import { cn } from "@/lib/utils";

interface SectionProps {
  children: ReactNode;
  className?: string;
  background?: "default" | "muted" | "gradient";
  id?: string;
}

export function Section({ 
  children, 
  className,
  background = "default",
  id
}: SectionProps) {
  const bgClasses = {
    default: "bg-background",
    muted: "bg-muted/50",
    gradient: "bg-gradient-to-b from-background to-muted/30"
  };
  
  return (
    <section id={id} className={cn("py-16 md:py-24", bgClasses[background], className)}>
      {children}
    </section>
  );
}
